import './_styles.scss';
import React from "react";
import numeral from 'numeral';
import { Carousel } from 'components';
import { MdShoppingCart } from 'react-icons/md';

const Image = (url) => ({ backgroundImage: `url(${url})` });

const format = (amount) => numeral(amount).format('0,0.00');

const Description = ({ description='' }) => description.substring(0, 100);

const Slider = ({ product={} }) => (
  <div className="Hero-Header-Content">

    <div className="Hero-Product-Details">

      <label className="Hero-Product-Brand">{product.vendor}</label>
      <div className="Hero-Product-Category">{product.category}</div>
      <div className="Hero-Product-Caption">
        {Description(product)}...
      </div>

      <div className="Hero-Product-Price">
        <div className="Discounted">Ksh {format(product.pricing.price)}</div>
        <div className="Actual">{format(product.pricing.compare)}</div>
      </div>

      <button className="Hero-Cart-Button">
        <MdShoppingCart className='Cart-Button-Label'/>
        <div className="label">Add to Cart</div>
      </button>

    </div>

    <div
      className="Hero-Product-Image"
      style={Image(product.images[0])}
    />

  </div>
);

export default ({ data=[] }) => (
  <div className='Hero-Header'>
    <Carousel loop auto axis='x' className="Slider">
      { data.map((a, index) => <Slider key={`${index}`} product={a}/>) }
    </Carousel>
  </div>
);
